import React from "react"
import { graphql, useStaticQuery } from "gatsby"
import Image from "gatsby-image/withIEPolyfill"
import browser from 'browser-detect'
import BackgroundImage from 'gatsby-background-image'
import { Link } from "@components/Link"
import { useURL } from "@hooks/useURL"
import { useGtm } from '@hooks/useGtm'
import { motion, AnimatePresence } from "framer-motion"
import { wrap } from "@popmotion/popcorn";

import css from "@css/components/blocks/IndexSct04.module.styl"

const Tabs = ({selectId, setSelectId}) => {
    const gtm = useGtm()
    const handler = (id,label) => {
        gtm.push(['FireEvent','arrows5G Adobe','click',label])
        setSelectId(id)
    }
    return(
        <div className={css.tabs}>
            <span className={`${css.item} ${ selectId === 0 ? css.focus : null}`} onClick={()=> handler(0,'傷の除去')}>傷の除去</span>
            <span className={`${css.item} ${ selectId === 1 ? css.focus : null}`} onClick={()=> handler(1,'コラージュ')}>コラージュ</span>
            <span className={`${css.item} ${ selectId === 2 ? css.focus : null}`} onClick={()=> handler(2,'文字入れ')}>文字入れ</span>
            <span className={`
                ${selectId === 0 ? css.focusBg_1 : null}
                ${selectId === 1 ? css.focusBg_2 : null}
                ${selectId === 2 ? css.focusBg_3 : null}
            `}></span>
        </div>
    )
}


const variants = {
    enter: (direction) => {
      return {
        // x: direction > 0 ? 1000 : -1000,
        opacity: 0
      };
    },
    center: {
    //   zIndex: 1,
    //   x: 0,
      opacity: 1
    },
    exit: (direction) => {
      return {
        // zIndex: 0,
        // x: direction < 0 ? 1000 : -1000,
        opacity: 0
      };
    }
  };
const swipeConfidenceThreshold = 10000
const swipePower = (offset, velocity) => {
    return Math.abs(offset) * velocity;
}

const device = ({q, selectId, setSelectId}) => {
    const [[page, direction], setPage] = React.useState([0, 0]);
    const images = [
        q.device1.childImageSharp.fluid,
        q.device2.childImageSharp.fluid,
        q.device3.childImageSharp.fluid
    ]
    const imageIndex = wrap(0, images.length, page)
    const paginate = (newDirection) => {
        setPage([page + newDirection, newDirection]);
    }
    React.useEffect(()=>{
        setPage([selectId,selectId])
    },[selectId])
    
    return(
        <div className={css.device}>
            <div className={css.base}>
                <Image fluid={q.device0.childImageSharp.fluid}/>
            </div>
            <div className={css.photos}>
                { images.map( ( fluid , i ) => {
                    return(
                        <div className={css.item} key={i} style={{opacity: imageIndex !== i ? 0 : 1}}>
                            <Image fluid={fluid}/>
                        </div>
                    )
                }) }
            </div>
        </div>
    )
}

export default function IndexHero()
{
    const q = useStaticQuery(graphql`
        query {
            device0: file(relativePath: { eq: "Hero__img__device-front@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 320) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            device1: file(relativePath: { eq: "Sct04__img__device-1@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            device2: file(relativePath: { eq: "Sct04__img__device-2@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            device3: file(relativePath: { eq: "Sct04__img__device-3@2x.png" }) {
                childImageSharp {
                    fluid(maxWidth: 640) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
            bg: file(relativePath: { eq: "Sct04__img__scroll-bg@2x.jpg" }) {
                childImageSharp {
                    fluid(maxWidth: 2704) {
                        ...GatsbyImageSharpFluid
                    }
                }
                publicURL
            }
        }
    `)
    const [selectId, setSelectId] = React.useState(0)

    const urls = useURL()
    const bgStyle = {
        backgroundImage: `url(${q.bg.childImageSharp.fluid.src})`
    }
    return pug`
        div(className=${css.container})
            div(className=${css.inner})
                h2(className=${css.title})
                    span
                        strong 顔の傷を消したり、
                    br
                    span
                        strong コラージュ、
                    | 
                    span
                        strong 文字入れ…
                    span すべてが思いのまま！
            div(className=${css.main})
                div(className=${css.bg} style=${bgStyle})
                ${device({q, selectId, setSelectId})}
            div(className=${css.inner})
                ${Tabs({selectId, setSelectId})}

                p(className=${css.text})
                    |撮影して即編集、今しかない気持ちを写真にのせてそのままシェア。
                    br
                    |こんな５G時代の新しい撮影体験をAdobe Photoshop Expressとarrows 5Gは提供します。
                
            
        `
}

